import { LogOut, ChevronDown } from "lucide-react";
import { useCore } from "../lib/core";
import { Dropdown } from "@praesto/ui-kit";

export function UserMenu() {
  const core = useCore();
  const user = core.auth.currentUser();
  const initial = user?.email?.[0]?.toUpperCase() ?? "?";

  return (
    <Dropdown
      align="right"
      triggerAriaLabel="Menu utente"
      trigger={
        <span className="flex items-center gap-1.5 rounded-md p-1 transition-colors duration-fast hover:bg-hover">
          {/* Monochrome avatar on purpose: a per-person palette would draw
              from Spectrum or the states, the two reserved color families. */}
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-subtle text-mono-xs font-medium text-fg-muted">
            {initial}
          </span>
          <ChevronDown size={14} className="text-fg-muted" />
        </span>
      }
      items={[
        ...(user?.email ? [{ type: "header" as const, label: user.email }] : []),
        ...(user?.id ? [{ type: "header" as const, label: `uid: ${user.id.slice(0, 8)}…` }] : []),
        // Which build am I actually looking at? Without this, a stale service
        // worker and a deploy that never happened look identical.
        { type: "header" as const, label: `versione ${__BUILD_ID__}` },
        { type: "separator" as const },
        {
          type: "item" as const,
          label: "Esci",
          icon: <LogOut size={14} />,
          onClick: () => void core.auth.signOut(),
          danger: true,
        },
      ]}
    />
  );
}
